// import React, { useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Typography,
//   Alert,
//   CircularProgress,
// } from "@mui/material";
// import { addUserToCashier } from "../../../../../services/Users";

// const LinkCashierDialog = ({ userId, cashier, onClose, onSuccess }) => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   if (!cashier) return null;

//   const { id: cashierId, name: cashierName } = cashier;

//   const handleConfirm = async () => {
//     setLoading(true);
//     setError(null);

//     try {
//       await addUserToCashier({ user_id: userId, cashier_id: cashierId });
//       if (onSuccess) onSuccess();
//       onClose();
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
//       <DialogTitle>تأكيد ربط الكاشير</DialogTitle>
//       <DialogContent>
//         <Typography mb={2}>
//           هل تريد تفعيل الكاشير <strong>{cashierName}</strong> لهذا المستخدم؟
//         </Typography>
//         {error && <Alert severity="error">{error}</Alert>}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} disabled={loading}>
//           إلغاء
//         </Button>
//         <Button
//           onClick={handleConfirm}
//           variant="contained"
//           color="primary"
//           disabled={loading}
//         >
//           {loading ? <CircularProgress size={20} /> : "✅ تأكيد الربط"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default LinkCashierDialog;

import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import { addUserToCashier } from "../../../../../services/Users";

const LinkCashierDialog = ({ userId, cashier, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  if (!cashier) return null;

  const { id: cashierId, name: cashierName } = cashier;

  const handleConfirm = async () => {
    setLoading(true);
    setError(null);
    setSuccessMessage(null);

    try {
      await addUserToCashier({ user_id: userId, cashier_id: cashierId });
      setSuccessMessage(`✅ تم ربط الكاشير "${cashierName}" بالمستخدم بنجاح`);

      if (onSuccess) onSuccess();

      setTimeout(() => {
        onClose();
      }, 1500); // ⏱️ بعد 1.5 ثانية
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>تأكيد ربط الكاشير</DialogTitle>
      <DialogContent>
        <Typography mb={2}>
          هل تريد تفعيل الكاشير <strong>{cashierName}</strong> لهذا المستخدم؟
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {successMessage && <Alert severity="success">{successMessage}</Alert>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          إلغاء
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          disabled={loading || successMessage}
        >
          {loading ? <CircularProgress size={20} /> : "✅ تأكيد الربط"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkCashierDialog;
